import { API } from "aws-amplify";

const API_NAME = "foodDelivery";

const getStorePath = (institution) => `/admin/settings/${institution}/0`;
const getDiscountPath = (institution) => `/admin/discount/${institution}`;
const getUsersPath = (institution) => `/admin/list-user/${institution}`;
const getItemsPath = (institution) => `/any/items/${institution}`;
const getOrdersPath = (institution) => `/user/order/${institution}`;
const getOrderStatusPath = (institution, orderId) => `/admin/order/${institution}/${orderId}/status`;

export const fetchStoreStatus = (institution) =>
  API.get(API_NAME, getStorePath(institution), {
    queryStringParameters: { type: "onoff" },
  });

export const updateStoreStatus = (institution, status) =>
  API.post(API_NAME, getStorePath(institution), {
    queryStringParameters: { type: "onoff" },
    body: {
      status,
      offMode: "manual",
      message: status === "on" ? "Restaurant is Open" : "Restaurant is Closed",
    },
  });

export const fetchDiscount = (institution) =>
  API.get(API_NAME, getDiscountPath(institution));

export const saveDiscount = (institution, payload) =>
  API.put(API_NAME, getDiscountPath(institution), { body: payload });

export const deleteDiscount = (institution) =>
  API.del(API_NAME, getDiscountPath(institution));

export const fetchUsers = (institution) =>
  API.get(API_NAME, getUsersPath(institution));

export const createUser = (institution, payload) =>
  API.post(API_NAME, `/admin/create-user/${institution}`, { body: payload });

export const updateUser = (institution, payload) =>
  API.put(API_NAME, `/admin/update-user/${institution}`, { body: payload });

export const deleteUser = (institution, cognitoId) =>
  API.del(API_NAME, `/admin/delete-user/${institution}/${encodeURIComponent(cognitoId)}`);

export const fetchItems = (institution) =>
  API.get(API_NAME, getItemsPath(institution));

export const createItem = (institution, payload) =>
  API.post(API_NAME, `/admin/items/${institution}`, { body: payload });

export const updateItem = (institution, itemId, payload) =>
  API.put(API_NAME, `/admin/items/${institution}/${itemId}`, { body: payload });

export const deleteItem = (institution, itemId) =>
  API.del(API_NAME, `/admin/items/${institution}/${itemId}`);

export const fetchOrders = (institution) =>
  API.get(API_NAME, getOrdersPath(institution));

export const updateOrderStatus = (institution, orderId, payload) =>
  API.put(API_NAME, getOrderStatusPath(institution, orderId), { body: payload });
